// extracted by mini-css-extract-plugin
export default {"global-layout":"Global_global-layout__vzr-n","global-layout__body":"Global_global-layout__body__B48-2","global-layout__body--body":"Global_global-layout__body--body__r-saD"};